/*  eslint-disable */
import React, { useEffect } from "react"
import Helmet from "react-helmet"
import { ThemeProvider } from "styled-components"
import posthog from 'posthog-js'

import config from "../../config"
import EWebinarScript from "./ewebinar"
import FontFace from "./FontFace"

const defaultTheme = require("tailwindcss/defaultConfig").theme
const theme = { ...defaultTheme, ...require("../../../tailwind") }

const PostHogProvider = ({ children }) => {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      try {
        posthog.init('phc_X5PzXFv66DGpXTusWJQdGNzdDAVCOA1hqtwI7yr0Zee', {
          api_host: 'https://us.i.posthog.com',
          person_profiles: 'identified_only',
          capture_pageview: true,
          capture_pageleave: true,
          loaded: (ph) => {
            let checkInterval

            // this will be called every time a new session starts
            ph.onSessionId((sessionId) => {
              clearInterval(checkInterval)

              // setup a check for the condition that means the recording is interesting enough to be watched
              checkInterval = setInterval(() => {
                // we want to read the session data, but not change it, so we pass `true`
                const { 
                  lastActivityTimestamp, 
                  sessionId 
                } = ph.sessionManager.checkAndGetSessionAndWindowId(true)
                
                const sinceLastActivity = Math.abs(new Date().getTime() - lastActivityTimestamp)
                const fiveMinutesInMillis = 5 * 60 * 1000
                if (sinceLastActivity > fiveMinutesInMillis) {
                  // capture an event that will be used to trigger the posthog destination
                  ph.capture('session_idle_for_five_minutes', {
                    sessionURL: ph.get_session_replay_url({ withTimestamp: true }),
                    idleSessionId: sessionId,
                  })

                  // clear the interval so we only send the event once
                  clearInterval(checkInterval)
                }
              }, 5000)
            })
          }
        })
      } catch (error) {
        console.error('Failed to initialize PostHog:', error)
      }
    }
  }, [])

  return children
}

const BearAIProvider = ({ children }) => {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      try {
        // Bear AI tracking script
        (function() {
          var params = new URLSearchParams(window.location.search);
          var tracking = new URLSearchParams();
          var utmParams = ['utm_source','utm_medium','utm_campaign','utm_content','utm_term'];

          tracking.set('project_id','6ef673c8-7665-4050-98e5-e24e7b1e9509');

          for (var i = 0; i < utmParams.length; i++) {
            var value = params.get(utmParams[i]);
            if (value) tracking.set(utmParams[i], value);
          }

          if (document.referrer) tracking.set('page_referrer', document.referrer);

          var pixelUrl =
            'https://yqagkqabd5.us-east-2.awsapprunner.com/api/track/pixel.gif?' +
            tracking.toString();

          var img = new Image();
          img.src = pixelUrl;
          img.width = 1;
          img.height = 1;
          img.style.position = 'absolute';
          img.style.left = '-9999px';
          document.body.appendChild(img);

          !function(e, r) {
            try {
              if (e.vector) return;
              var t = {};
              t.q = t.q || [];
              var o = ["load", "identify", "on"];
              var n = function(name) {
                return function() {
                  var args = Array.prototype.slice.call(arguments);
                  t.q.push([name, args]);
                };
              };
              for (var c = 0; c < o.length; c++) {
                var a = o[c];
                t[a] = n(a);
              }
              if (!t.loaded) {
                var i = r.createElement("script");
                i.type = "text/javascript";
                i.async = true;
                i.src = "https://cdn.vector.co/pixel.js";
                var l = r.getElementsByTagName("script")[0];
                l.parentNode.insertBefore(i, l);
                t.loaded = true;
              }
              e.vector = t;
            } catch (err) {}
          }(window, document);

          window.vector.partnerId = '6ef673c8-7665-4050-98e5-e24e7b1e9509';
          window.vector.load("f9b6a15a-a9f8-4f25-8db6-dcfb8125f006");
        })();
      } catch (error) {
        console.error('Failed to initialize Bear AI:', error)
      }
    }
  }, [])

  return children
}

const Head = () => (
  <Helmet>
    {/* <script type="text/javascript" async>
      {`(function(o){var b="https://turboeagle.co/anywhere/",t="8eefb0a364984bddabdd439956bccea1187eda0a1b354659b7acbdc18e297203",a=window.AutopilotAnywhere={_runQueue:[],run:function(){this._runQueue.push(arguments);}},c=encodeURIComponent,s="SCRIPT",d=document,l=d.getElementsByTagName(s)[0],p="t="+c(d.title||"")+"&u="+c(d.location.href||"")+"&r="+c(d.referrer||""),j="text/javascript",z,y;if(!window.Autopilot) window.Autopilot=a;if(o.app) p="devmode=true&"+p;z=function(src,asy){var e=d.createElement(s);e.src=src;e.type=j;e.async=asy;l.parentNode.insertBefore(e,l);};y=function(){z(b+t+'?'+p,true);};if(window.attachEvent){window.attachEvent("onload",y);}else{window.addEventListener("load",y,false);}})({});`}
    </script> */}
    <link rel="preconnect" href={`${config.HANDBOOK_HOST}`} />
    <link rel="preconnect" href="https://trycom.s3.amazonaws.com" />
    <link rel="preconnect"
          href="https://fonts.gstatic.com"
          crossorigin />
    <link rel="preload"
          as="style"
          href="https://fonts.googleapis.com/css?family=Lato:300,400,700&display=swap"
          onload="this.rel='stylesheet'" />
    <script src="https://tag.clearbitscripts.com/v1/pk_593faa992e333a02802d142dcb4e9e38/tags.js"></script>
  </Helmet>
)

const Layout = ({ children }) => {
  return (
    <>
      <ThemeProvider theme={theme}>
        <PostHogProvider>
          <BearAIProvider>
            <React.Fragment>
              <FontFace />
              <Head />
              {children}
            </React.Fragment>
          </BearAIProvider>
        </PostHogProvider>
      </ThemeProvider>
    </>
  )
}

export default Layout
